var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style[_vm.color]},[_c('el-icon',{class:_vm.$style.icon,attrs:{"name":_vm.icon}}),_c('span',{class:_vm.$style.capitalize},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }